import { AuthMessage, AuthMessageType, PeerIdType } from '@playcastdotio/Messaging';
import { requestPeerId, setIsReady } from '..';

export const handleAuthMessage = (message: AuthMessage) => {
  console.log('Auth message:', message);
  switch (message.type) {
    case AuthMessageType.AUTH_SUCCESS: {
      console.log('Auth success');
      setIsReady(true);
      requestPeerId(PeerIdType.REMOTE_HOST);
    }
  }
};
